





















import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 点击奖励
      handleBonusClick = () => {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa86d67aebce0f017b5312b47a0010',
        })
      }
    },
)
